export default {
    title: "Controllo di gestione",
    icon: "mdi-chart-timeline-variant",
    groups: ["Amministrazione"],
    submenu: [
        { title: "Sintesi", route: { name: "gestione-riepilogo" }, exact: true, exactPath: true, groups: ["Amministrazione"] },
        { title: "Costi", route: { name: "gestione-spese" }, groups: ["Amministrazione"] },
        { title: "Bilancio", route: { name: "gestione-bilancio" }, groups: ["Amministrazione"] },
        { title: "Attendibilità dei dati", route: { name: "gestione-riconciliazione" }, groups: ["Amministrazione"] },
    ],
};
